import fetch from './axios'
// 责任接口
/* 
获取社会责任列表接口
@params{*} param 相关参数(全部可选)
status可选	integer	 状态 0 下架 1 上架
title       string  标题
per_page    integer  每页显示条数 默认值: 10
page        integer  第几页 默认值: 1
*/
export const getDutyList = param => fetch.get('/api/responsibility/list', param)
/* 
社会责任详情接口
@params{*} param 相关参数
id	integer	 id
*/
export const detailDuty = param => fetch.get('api/responsibility/detail', param)
// 大事件接口
/* 
大事件列表接口
@params{*} param 相关参数 全部可选
content 可选	string	 内容
status可选	integer	 状态筛选 0 下架 1上架
per_page可选	integer	 每页显示条数 默认值: 10
page可选	integer	 第几页 默认值: 1
*/
export const bigEventList = param => fetch.get('api/big_event/list', param)
// 我们的故事接口
/* 
@api/responsibility/list
心田故事列表接口
@params{*} param 相关参数 
title可选	string	 标题
status可选	integer	 状态筛选 0 下架 1 上架
per_page可选	integer	 每页显示条数 默认值: 10
page可选	integer	 第几页 默认值: 1
*/
export const storyList = param => fetch.get('api/story/list', param)
// 平台信息接口
/* 
平台信息详情接口
@params{*} param 相关参数 
keys可选	array	[website_title,app,products] 默认值: 所有
*/
export const platformDetail = param => fetch.get('api/setting/detail', param)
// 分校列表接口
/* 
@params{*} param 相关参数 
*/
export const campusList = param => fetch.get('api/campus/list', param)